<!-- Revised on 2024/11/27 by mnavarro -->
<template>
  <div class="col-lg-4 col-md-6 col-12 dataTable-info">
    <div v-if="total != 0" class="dataTable-info">
      <nav class="dataTable-pagination">
        <ul class="dataTable-pagination-list">
          <li v-if="current > 5" style="cursor: pointer;" class="pager" :data-page="current + 5"><a :title="$t('key_pager_goto_page') + ' ' + (current - 5)" @click="skipPages(-5)">‹‹</a></li>
          <li v-if="current > 1" style="cursor: pointer;" class="pager" :data-page="current + 1"><a :title="$t('key_pager_goto_page') + ' ' + (current - 1)" @click="skipPages(-1)">‹</a></li>
          <li v-for="(item, index) of rango" :id="index + 1" :key="index" style="cursor: pointer;" :class="getClasses(item, current)" :data-page="index">
            <a v-if="current == index + 1" :title="$t('key_pager_page') + ' ' + item" @click="changedPage(item)">{{ item }}</a>
            <a v-else :title="$t('key_pager_goto_page') + ' ' + item" @click="changedPage(item)">{{ item }}</a>
          </li>
          <li v-if="(total - current) >= 1" style="cursor: pointer;" class="pager" :data-page="current - 1"><a :title="$t('key_pager_goto_page') + ' ' + (current + 1)" @click="skipPages(1)">›</a></li>
          <li v-if="(total - current) > 5" style="cursor: pointer;" class="pager" :data-page="current - 5"><a :title="$t('key_pager_goto_page') + ' ' + (current + 5)" @click="skipPages(5)">››</a></li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Pager",
    props: {
      color: {
        type: String,
        default: "success",
      },
      size: {
        type: String,
        default: "md",
      },
      total: {
        type: Number,
        default: 1
      },
      current: {
        type: Number,
        default: 1,
      },
    },
    emits: ['changed-page'],
    computed: {
      rango() {
        let ret = [];
        let start = 0;
        let items = 5;
        if (this.total < items) {
          items = this.total;
        }
        if (this.current - 3 > 0) {
          start = this.current - 3;
        }
        if (this.current + 3 > this.total) {
          start = this.total - items;
        }
        for (let index = start; index < start + items; index++) {
          ret.push(index + 1);
        }
        return ret;
      }
    },
    methods: {
      changedPage(index) {
        this.$emit('changed-page', index);
      },
      skipPages(pages) {
        let toPage = this.current + pages;
        if (toPage <= 0) {
          toPage = 1;
        }
        if (toPage > this.total) {
          toPage = this.total;
        }
        this.changedPage(toPage);
      },
      getClasses(index, current) {
        return index === current ? "active" : "";
      },
    },
  };

</script>